export function generateRandomString(): string {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);

  return Array.from(array)
    .map((d) => d.toString(16))
    .join("");
}
